import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import styled from "styled-components";


const GetStartedBtn = () => {
    const navigate = useNavigate();
    const accessToken = useSelector((state) => state.auth.userData?.accessToken);

    const handleButtonEvent = () => {
        if (accessToken) {
            navigate("/dashboard");
        } else {
            navigate("/register");
        }
    }


    return (
        <Button onClick={handleButtonEvent}>
            Get Started
        </Button>
    );
};

export default GetStartedBtn;


const Button = styled.button`
padding: 2rem;
  background-color: var(--orange);
  border: none;
  border-radius: 1rem;
  font-size: 2rem;
  color: #ffffff;
  margin-top: 20px;
  cursor: pointer;


`